// Gera um CSV client-side a partir de rows + colunas e dispara download.
// Escapa aspas e valores com vírgula.
//
// Uso:
//   exportCsv({
//     filename: 'lojas.csv',
//     columns: [
//       { key: 'id', header: 'ID' },
//       { key: 'name', header: 'Nome' },
//       { key: 'status', header: 'Status', format: (s) => STATUS_LABEL[s] || s },
//     ],
//     rows,
//   });

function escape(value) {
  if (value == null) return '';
  const s = String(value);
  if (/[",\n]/.test(s)) {
    return `"${s.replace(/"/g, '""')}"`;
  }
  return s;
}

export function exportCsv({ filename = 'export.csv', columns, rows }) {
  if (!columns?.length) return;

  const header = columns.map((c) => escape(c.header)).join(',');
  const lines = rows.map((row) =>
    columns
      .map((col) => {
        const raw = col.key ? row[col.key] : undefined;
        const value = col.format ? col.format(raw, row) : raw;
        return escape(value);
      })
      .join(',')
  );

  const csv = [header, ...lines].join('\n');
  // BOM pra Excel abrir em UTF-8 correto.
  const blob = new Blob(['﻿' + csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

export default exportCsv;
